export default __webpack_public_path__ + "static/vietnam-bike-tour-4-618ab2ca43c4652bba25b0b134d83b6e.jpeg";